import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';

import {useApolloClient} from '@apollo/client';

import { 
  fetchOneDomainInstance,
  OperationTargets
} from '../../api/CommonCrudOperations'

import LTRDomainObjectInfo from '../shared/domains/LTRDomainObjectInfo';

// Our labels in the Info Table
const labels = {
  type: "TYPE",
  description: "DESCRIPTION",
  contact: "CONTACT",
  billType: "TYPE OF BILL",
  billingFrequency: "BILL FREQUENCY",
  howPaid: "HOW PAID",
  notes: "NOTES"
}

export const prepareTableRowInfo = (service) => {
  // prepare table data for show
  let messageAction = '';
  let messageDoc = '';
  if (service.actionItems) {
    messageAction = service.actionItems.length === 0 ? "This service has NO action items" :
    "This service has " + service.actionItems.length + " action items";
  }
  if (service.attachments) {
    messageDoc = service.attachments.length === 0 ? "This service has NO attached files":
    "This service has " + service.attachments.length + " attached files"
  }
  const tableInfo = {
    name: service.name,
    actionItemMessage: messageAction,
    documentsMessage: messageDoc,
    fieldData : [
      {
        field: labels.type,
        value: service.type
      },
      {
        field: labels.description,
        value: service.description
      },
    ]
  }
  const contact = {
    field: labels.contact,
    value: service.contact !== null ? service.contact.name : ''
  }
  tableInfo.fieldData.push(contact);

  let billerData;
  if (service.billers && service.billers.length > 0) {
    const biller = service.billers[0];   
    billerData = [
      {
        field: labels.billType,
        value: biller.billType
      },
      {
        field: labels.howPaid,
        value: biller.howPaid
      },
      {
        field: labels.billingFrequency,
        value: biller.billingFrequency
      },  
    ] 
  } else {
    billerData = billerData = [
      {
        field: labels.billType,
        value: ''
      },
      {
        field: labels.howPaid,
        value: ''
      },
      
      {
        field: labels.billingFrequency,
        value: ''
      },  
    ]
  }
  // add the biller data
  tableInfo.fieldData = tableInfo.fieldData.concat(billerData);
  
  // finally, notes
  const notesData = {
    field: labels.notes,
    value: service.notes
  }
      
  tableInfo.fieldData.push(notesData);

  return tableInfo;  
}

const useServiceFetch = (client, domainId, updateFn) => {
  const [service, setService] = useState(null);
  
  useEffect(() => {
    const fetchService = () => { 
      fetchOneDomainInstance(client, OperationTargets.Services, domainId)
      .then(result => { 
        const service = result.item;
        setService(service);
        updateFn(service);
      })
      .catch(error => {
        console.log(error) 
      });
    }

    if (service === null && domainId !== null) {
      fetchService()
    }  
  }, [client, updateFn]);
};

const ServiceInfo = (props) => {
  const client = useApolloClient();

  const [showInfoDialogOpen, setShowInfoDialogOpen] = useState(false);
  const [tableInfo, setTableInfo] = useState(null);
  const [service, setService] = useState(null);

  const handleShowInfoClose = () => {
    setShowInfoDialogOpen(false);
    // notify the client
    props.handleClose();
  }

  useServiceFetch(client, props.domainId, (fetchedData) => {
    if (fetchedData !== null) {
      setService(fetchedData);
      const info = prepareTableRowInfo(fetchedData);
      setTableInfo(info);
      setShowInfoDialogOpen(true);
    }
  });

  if (tableInfo === null) {
    return null;
  }

  return (
    <React.Fragment>  
      {showInfoDialogOpen ? (
        <LTRDomainObjectInfo
          open = {props.open}
          title = {service.name}
          tableData = {tableInfo}
          handleClose = {handleShowInfoClose}
        />): null
      }
    </React.Fragment>
  )
}

ServiceInfo.propTypes = {
  open: PropTypes.bool.isRequired,
  domainId: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired
}

export default (ServiceInfo);
